/**
 * Safely read a human-readable message from a thrown API error. Mutations
 * surface `unwrap`'s normalized ApiError, but React Query types the callback
 * error as `Error`, so we narrow structurally rather than cast.
 *
 * DRF returns either `{detail}` (permission/validation top-level errors) or a
 * field-error map (`toApiError` puts these on `fieldErrors`). We prefer
 * `detail`, then fall back to the first field error so form validation reasons
 * (bad email, duplicate name, license cap reached) actually reach the user
 * instead of a generic fallback.
 */
export function apiErrorDetail(err: unknown): string | undefined {
  if (!err || typeof err !== "object") return undefined;

  const detail = (err as { detail?: unknown }).detail;
  if (typeof detail === "string") return detail;

  const fieldErrors = (err as { fieldErrors?: Record<string, unknown> })
    .fieldErrors;
  if (fieldErrors && typeof fieldErrors === "object") {
    for (const value of Object.values(fieldErrors)) {
      if (Array.isArray(value) && typeof value[0] === "string") return value[0];
      if (typeof value === "string") return value;
    }
  }
  return undefined;
}
